/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Accordion_Notags1Inputs */

const id_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tidak ada tag ditemukan`)
};

const ms_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tiada tag ditemui`)
};

const da_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tags fundet`)
};

const de_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keine Tags gefunden`)
};

const en_us2_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No tags found`)
};

const es_es2_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron etiquetas`)
};

const es_mx2_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No se encontraron etiquetas`)
};

const fil_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Walang nakitang tag`)
};

const fr_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aucun tag trouvé`)
};

const it_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nessun tag trovato`)
};

const hu_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nem található címke`)
};

const nl_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geen tags gevonden`)
};

const no_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingen tagger funnet`)
};

const pl_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nie znaleziono tagów`)
};

const pt_br2_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma tag encontrada`)
};

const pt_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nenhuma etiqueta encontrada`)
};

const ro_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nu s-au găsit etichete`)
};

const fi_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tageja ei löytynyt`)
};

const sv_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Inga taggar hittades`)
};

const vi_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không tìm thấy thẻ`)
};

const tr_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Etiket bulunamadı`)
};

const cs_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nebyly nalezeny žádné štítky`)
};

const bg_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Няма намерени етикети`)
};

const ru_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Теги не найдены`)
};

const uk_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Тегів не знайдено`)
};

const ar_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`لم يتم العثور على وسوم`)
};

const hi_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`कोई टैग नहीं मिला`)
};

const th_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ไม่พบแท็ก`)
};

const ja_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タグが見つかりません`)
};

const zh_cn2_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到标签`)
};

const zh_hant1_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`未找到標籤`)
};

const ko_search_accordion_notags1 = /** @type {(inputs: Search_Accordion_Notags1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`태그를 찾을 수 없음`)
};

/**
* | output |
* | --- |
* | "No tags found" |
*
* @param {Search_Accordion_Notags1Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const search_accordion_notags1 = /** @type {((inputs?: Search_Accordion_Notags1Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Accordion_Notags1Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_search_accordion_notags1(inputs)
	if (locale === "ms") return ms_search_accordion_notags1(inputs)
	if (locale === "da") return da_search_accordion_notags1(inputs)
	if (locale === "de") return de_search_accordion_notags1(inputs)
	if (locale === "en-US") return en_us2_search_accordion_notags1(inputs)
	if (locale === "es-ES") return es_es2_search_accordion_notags1(inputs)
	if (locale === "es-MX") return es_mx2_search_accordion_notags1(inputs)
	if (locale === "fil") return fil_search_accordion_notags1(inputs)
	if (locale === "fr") return fr_search_accordion_notags1(inputs)
	if (locale === "it") return it_search_accordion_notags1(inputs)
	if (locale === "hu") return hu_search_accordion_notags1(inputs)
	if (locale === "nl") return nl_search_accordion_notags1(inputs)
	if (locale === "no") return no_search_accordion_notags1(inputs)
	if (locale === "pl") return pl_search_accordion_notags1(inputs)
	if (locale === "pt-BR") return pt_br2_search_accordion_notags1(inputs)
	if (locale === "pt") return pt_search_accordion_notags1(inputs)
	if (locale === "ro") return ro_search_accordion_notags1(inputs)
	if (locale === "fi") return fi_search_accordion_notags1(inputs)
	if (locale === "sv") return sv_search_accordion_notags1(inputs)
	if (locale === "vi") return vi_search_accordion_notags1(inputs)
	if (locale === "tr") return tr_search_accordion_notags1(inputs)
	if (locale === "cs") return cs_search_accordion_notags1(inputs)
	if (locale === "bg") return bg_search_accordion_notags1(inputs)
	if (locale === "ru") return ru_search_accordion_notags1(inputs)
	if (locale === "uk") return uk_search_accordion_notags1(inputs)
	if (locale === "ar") return ar_search_accordion_notags1(inputs)
	if (locale === "hi") return hi_search_accordion_notags1(inputs)
	if (locale === "th") return th_search_accordion_notags1(inputs)
	if (locale === "ja") return ja_search_accordion_notags1(inputs)
	if (locale === "zh-CN") return zh_cn2_search_accordion_notags1(inputs)
	if (locale === "zh-Hant") return zh_hant1_search_accordion_notags1(inputs)
	return ko_search_accordion_notags1(inputs)
});
export { search_accordion_notags1 as "search.accordion.noTags" }